import {Parameter, ToolboxOutlineOutline} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalAddToolboxOutline} from "./PortalAddToolboxOutline";

export class PortalToolboxOutlineOutline extends ToolboxOutlineOutline implements Parameter {
	constructor(data: any) {
		super(data);

		this.add = PortalAddToolboxOutline.fromJson(data?.add);
	}

	public static fromJson(data: any): PortalToolboxOutlineOutline {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalToolboxOutlineOutline(data);
	}

	public clone(): PortalToolboxOutlineOutline {
		return PortalToolboxOutlineOutline.fromJson(this.toJson());
	}
}